import { render, staticRenderFns } from "./InsuranceAgreements.vue?vue&type=template&id=c2d3e082&scoped=true"
import script from "./InsuranceAgreements.vue?vue&type=script&lang=ts"
export * from "./InsuranceAgreements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d3e082",
  null
  
)

export default component.exports